
import Load from './components/load/Load';
import Container from './components/container/Container';
import AppProvider from './context/AppProvider'
import './App.css';

function App() {

  return (
    <AppProvider>
      <div className="App">
        <Load />
        <Container />
      </div>
    </AppProvider>
    
  );
}

export default App;
